<template>
  <section
    class="px-6 xl:px-10"
  >
    <div
      class="width-sm mx-auto py-8 xl:py-16"
    >
      <div
        class="font-light text-xs xl:text-lg leading-loose"
      >
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageSection',
};
</script>
